import { ArrowLeftToLineIcon } from 'lucide-react';

import ControlButton from './ControlButton';

function PreviousButton({ onClick }: { onClick: () => void }) {
  return (
    <ControlButton onClick={onClick} aria-label="Start of step">
      <ArrowLeftToLineIcon className="size-6" />
    </ControlButton>
  );
}

export default PreviousButton;
